module.exports = __webpack_public_path__ + "static/media/90600.acd40841.png";